/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { IonApp, IonContent, IonPage, IonRouterOutlet } from '@ionic/react';
import { dispatch, ErrorBoundary, useAppState } from 'oasis-os-react';
import { ThemeProvider } from 'oasis-os-theming';
import { IonReactRouter } from '@ionic/react-router';
import { useAuth } from 'oasis-auth';
import { Analytics, handleProviderMsgExchange, readGlobal } from 'oasis-os-common';
import { errorMessageRenderer } from '../../Viewport/errors';
import Routes from '../../Routes';
import { ContentfulApp } from '../../../types';
import RootFeatures from '../../RootFeatures';
import { getSilentInfo } from '../../../utils/getSilentInfo';
import './style.css';
import { ProviderExcgEventType, ProviderExcgStatusType } from 'oasis-os-provider-messaging';

export interface SimpleProps {
  config: ContentfulApp;
}

const ProviderMsgExchange: React.FC = () => {
  const [, , app] = useAppState();
  const [handleNativeBack, setHandleNativeBack] = React.useState<boolean>(false);
  const [nativeEventSuccess, setNativeEventSuccess] = React.useState<boolean>(false);

  React.useEffect(() => {
    handleProviderMsgExchange();
    app.registerAction('providerExchangeMsg', (message: any) => {
      if (message?.event === ProviderExcgEventType?.Back) setHandleNativeBack(true);
      if (
        (message?.event === ProviderExcgEventType?.Share ||
          message?.event === ProviderExcgEventType?.Download) &&
        message?.status === ProviderExcgStatusType?.Success
      )
        setNativeEventSuccess(true);
    });
  }, []);

  React.useEffect(() => {
    if (handleNativeBack) {
      dispatch('*', 'handleNativeBack', true);
      setHandleNativeBack(false);
    }
    if (nativeEventSuccess) {
      dispatch('*', 'nativeEventSuccess', true);
      setNativeEventSuccess(false);
    }
  }, [handleNativeBack, nativeEventSuccess]);

  return null;
};

const Simple: React.FC<SimpleProps> = ({ config }: SimpleProps) => {
  const { fields: appConfig } = config;
  const [auth] = useAuth();
  const analytics = getSilentInfo('analytics', appConfig?.config?.fields?.analytics);
  const isStandAloneApp =
    readGlobal('$.global.value.functionalConfig.platform.type') === 'stand-alone';

  return (
    <ThemeProvider icons={appConfig?.icons} locale={appConfig?.locale}>
      <IonApp className="pwa" data-testid="ion-app">
        <IonReactRouter basename={process.env.PUBLIC_PATH || '/'}>
          <IonPage id="main">
            <IonContent>
              <ErrorBoundary errorMessage={errorMessageRenderer}>
                <IonRouterOutlet
                  data-testid="router-outlet"
                  className="pwa__simple-template__router-outlet__fixed-router-position"
                >
                  <Routes />
                </IonRouterOutlet>
              </ErrorBoundary>
            </IonContent>
          </IonPage>
          {isStandAloneApp && <ProviderMsgExchange />}
          <RootFeatures />
        </IonReactRouter>
        {appConfig?.config?.fields?.analytics && auth.authenticated && (
          <Analytics config={analytics} isEnabled={isStandAloneApp} />
        )}
      </IonApp>
    </ThemeProvider>
  );
};
export default Simple;
